import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { COMMON_FAIL_MESSAGE, converDateIntoLocal } from "Constants";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import LocaleStrings from "Languages";
import {
  openChangeReviewer,
  makeShortlisted,
  openProposalResponseModal,
  openProposalSendTicketModal,
  openProposalConfirmModal,
} from "ProposalAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { createSpeaker } from "ActionsSpeakers";
import { addAppUser, sendWelcomeMail } from "DashboardUserAction";
import { validateEmailForAppUser } from "DashboardMenuAction";
import { fetchAllSpeakers } from "ActionsSpeakers";

class ResponseItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
      loading: false,
      welcomelogin: false,
      sendwelcomemail: false,
    };
  }

  changeReviewer = () => {
    let { response } = this.props;
    this.props.openChangeReviewer(true, response);
  };

  makeShortList = () => {
    let { response } = this.props;
    this.setState({ loading: true });
    let values = {};
    values.status = "shortlisted";
    values.id = response.id;
    this.props.makeShortlisted(this.props.session, values, (response) => {
      //console.log('proposal',response);
      if (response.success === 0) {
        this.setState({ loading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.setState({ loading: false });
        this.props.showSuccess(LocaleStrings.proposal_shorlisted_succesfully);
        this.props.handleSelect("shortlisted");
      }
    });
  };

  viewResponse = () => {
    let { response, selectedTab } = this.props;

    this.props.openProposalResponseModal(true, response, selectedTab);
  };

  confirmProposal = () => {
    let { response, selectedTab, userCategoryList, session, handleSelect } =
      this.props;

    // this.props.openProposalConfirmModal(true, response, handleSelect);
    this.props.openProposalConfirmModal(true, response); // WIthout HandelSelect
    /* confirmAlert({
      title: LocaleStrings.proposal_send_welcome_mail,
      message: LocaleStrings.proposal_send_welcome_mail_confirmation,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      onConfirm: () => {
        let values = {};
        values.firstname = response.firstname;
        values.lastname = response.lastname;
        values.email = response.email;
        values.eventid = session.eventid;
        let speaker = {};
        let uservalues = {};
        var speakerDetails = _.filter(userCategoryList.data, (obj) => {
          return obj.type == "speaker";
        });
        uservalues.usercategory =
          speakerDetails.length > 0 ? speakerDetails[0].id : "";
        uservalues.username = response.firstname + " " + response.lastname;
        uservalues.firstname = response.firstname;
        uservalues.lastname = response.lastname;
        uservalues.email = response.email;
        uservalues.eventid = session.eventid;
        uservalues.comesfrom = "admin";
        uservalues.isadmin = 0;

        this.setState({ welcomelogin: true });
        this.props.validateEmailForAppUser(
          this.props.session,
          uservalues,
          (validationresponse) => {
            if (validationresponse.success === 2) {
              this.props.showError(validationresponse.message);
              this.setState({ loading: false });
            } else if (validationresponse.success == 1) {
              this.props.createSpeaker(
                this.props.session,
                values,
                (feedback) => {
                  if (feedback.success === 0) {
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  } else {
                    var speakerid = feedback.speakerid;
                    uservalues.speakeridfk = speakerid ? speakerid : null;
                    //console.log('values',uservalues);

                    this.props.addAppUser(
                      this.props.session,
                      uservalues,
                      (response1) => {
                        if (response1.success === 0) {
                          this.setState({ welcomelogin: false });
                          this.props.showError(COMMON_FAIL_MESSAGE);
                        } else {
                          this.props.sendWelcomeMail(
                            this.props.session,
                            { email: response.email },
                            (response2) => {
                              //console.log("response2 second", response2);
                              if (response2.success === 1) {
                                this.props.fetchAllSpeakers(this.props.session);
                                this.props.showSuccess(
                                  LocaleStrings.user_message_welcome_email_sent
                                );
                                this.setState({ welcomelogin: false });
                              } else {
                                this.props.showError(COMMON_FAIL_MESSAGE);
                                this.setState({ welcomelogin: false });
                              }
                            }
                          );
                        }
                      }
                    );
                  }
                }
              );
            } else {
              this.setState({ welcomelogin: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            }
          }
        );
      },
      onCancel: () => {},
    }); */
  };

  sendWelcomeMail = () => {
    let {
      response,
      selectedTab,
      allSpeakers,
      allSponsors,
      allExhibitors,
      proposalAttendeeList,
    } = this.props;

    let attendeeList = [];
    if (
      proposalAttendeeList &&
      proposalAttendeeList.resource &&
      proposalAttendeeList.resource.length > 0
    ) {
      attendeeList = _.filter(proposalAttendeeList.resource, function (o) {
        return o.email === response.email;
      });
    }

    // let speakerList = [];
    // if (allSpeakers && allSpeakers.data && allSpeakers.data.length > 0) {
    //   speakerList = _.filter(allSpeakers.data, function (o) {
    //     return o.email === response.email;
    //   });
    // }

    // let sponsorList = [];
    // if (allSponsors && allSponsors.data && allSponsors.data.length > 0) {
    //   sponsorList = _.filter(allSponsors.data, function (o) {
    //     return (
    //       o.appuser_by_sponsoridfk.length > 0 &&
    //       o.appuser_by_sponsoridfk[0].email === response.email
    //     );
    //   });
    // }

    // let exhibitorList = [];
    // if (allExhibitors && allExhibitors.data && allExhibitors.data.length > 0) {
    //   exhibitorList = _.filter(allExhibitors.data, function (o) {
    //     return (
    //       o.appuser_by_exhibitoridfk.length > 0 &&
    //       o.appuser_by_exhibitoridfk[0].email === response.email
    //     );
    //   });
    // }
    //console.log('speakerList',speakerList);
    if (attendeeList.length > 0) {
      this.setState({ sendwelcomemail: true });
      this.props.sendWelcomeMail(
        this.props.session,
        { email: response.email },
        (response2) => {
          //console.log("response2 first", response2);
          this.setState({ sendwelcomemail: false });
          if (response2.success === 1) {
            this.props.showSuccess(
              LocaleStrings.user_message_welcome_email_sent
            );
          } else if (response2.success === 3) {
            this.props.showSuccess(
              LocaleStrings.user_message_welcome_email_error1
            );
          } else if (response2.success === 4) {
            this.props.showSuccess(
              LocaleStrings.user_message_welcome_email_error2
            );
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
        }
      );
    }
  };

  sendTicket = () => {
    let { response, handleSelect } = this.props;
    this.props.openProposalSendTicketModal(true, response, handleSelect);
  };

  render() {
    let {
      response,
      selectedTab,
      allSpeakers,
      allExhibitors,
      allSponsors,
      proposalAttendeeList,
    } = this.props;
    //console.log("proposalAttendeeList", proposalAttendeeList);
    let section = " - ";
    if (
      selectedTab == "unreviewed" &&
      response.proposal_by_proposalidfk &&
      response.proposal_by_proposalidfk.category
    ) {
      section = response.proposal_by_proposalidfk.category;
    } else if (
      (selectedTab == "reviewed" || selectedTab == "shortlisted") &&
      response.proposal_review_by_responseidfk &&
      response.proposal_review_by_responseidfk.length > 0
    ) {
      let sumRating = _.sumBy(
        response.proposal_review_by_responseidfk,
        function (o) {
          return o.rating;
        }
      );
      section = (
        sumRating / response.proposal_review_by_responseidfk.length
      ).toFixed(2);
    }
    let attendeeList = [];
    if (
      proposalAttendeeList &&
      proposalAttendeeList.resource &&
      proposalAttendeeList.resource.length > 0
    ) {
      attendeeList = _.filter(proposalAttendeeList.resource, function (o) {
        return o.email === response.email;
      });
    }

    // let speakerList = [];
    // if (allSpeakers && allSpeakers.data && allSpeakers.data.length > 0) {
    //   speakerList = _.filter(allSpeakers.data, function (o) {
    //     return o.email === response.email;
    //   });
    // }

    // let sponsorList = [];
    // if (allSponsors && allSponsors.data && allSponsors.data.length > 0) {
    //   sponsorList = _.filter(allSponsors.data, function (o) {
    //     return (
    //       o.appuser_by_sponsoridfk.length > 0 &&
    //       o.appuser_by_sponsoridfk[0].email === response.email
    //     );
    //   });
    // }

    // let exhibitorList = [];
    // if (allExhibitors && allExhibitors.data && allExhibitors.data.length > 0) {
    //   exhibitorList = _.filter(allExhibitors.data, function (o) {
    //     return (
    //       o.appuser_by_exhibitoridfk.length > 0 &&
    //       o.appuser_by_exhibitoridfk[0].email === response.email
    //     );
    //   });
    // }

    let sendwelcomeMail = false;
    let shortListedActionVisible = true;
    let confirmButton = true;

    // if (response.ticketurlsend == 0) {
    //   shortListedActionVisible = true;
    // }

    if (attendeeList.length > 0) {
      sendwelcomeMail = true;
      confirmButton = false;
      shortListedActionVisible = false;
    }
    //console.log("response", response);
    return (
      <tr>
        <td className="first-td">
          {response.firstname + " " + response.lastname}
        </td>
        <td className="middle-td">
          {converDateIntoLocal(response.submission_date)}
        </td>

        <td className="middle-td">{section}</td>
        <td className="middle-td">
          {response.reviewer_by_reviewerid
            ? response.reviewer_by_reviewerid.firstname +
              " " +
              response.reviewer_by_reviewerid.lastname
            : selectedTab == "reviewed" || selectedTab == "shortlisted"
            ? "Admin"
            : ""}
        </td>
        <td className="last-td" style={{ width: 400 }}>
          {selectedTab == "unreviewed" ? (
            <div style={{ display: "flex" }}>
              <div className="action-button" style={{ marginLeft: 5 }}>
                <button
                  className="btn btn-custom-table-white"
                  onClick={this.viewResponse}
                >
                  {LocaleStrings.proposal_for_response_button_view}
                </button>
              </div>
              <div className="action-button" style={{ marginLeft: 5 }}>
                {response.markas == "reject" ? (
                  <div style={{ paddingTop: 7, color: "#ff2828" }}>
                    {LocaleStrings.proposal_disqualified_text}
                  </div>
                ) : response.markas == "resubmit" ? (
                  <div
                    style={{
                      paddingTop: 7,
                      color: "#3c8638",
                      textTransform: "uppercase",
                    }}
                  >
                    re-submission
                  </div>
                ) : (
                  <button
                    className="btn btn-custom-table-white"
                    onClick={this.changeReviewer}
                  >
                    {response.reviewerid
                      ? LocaleStrings.proposal_for_response_button_change_reviewer
                      : LocaleStrings.proposal_for_response_button_assign_reviewer}
                  </button>
                )}
              </div>
            </div>
          ) : selectedTab == "reviewed" ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="action-button" style={{ marginLeft: 5 }}>
                <button
                  className="btn btn-custom-table-white"
                  onClick={this.viewResponse}
                >
                  {LocaleStrings.proposal_for_response_button_view}
                </button>
              </div>
              <div className="action-button" style={{ marginLeft: 5 }}>
                {response.markas == "reject" ? (
                  <span
                    className="badge badge-danger"
                    style={{ background: "#dc3545" }}
                  >
                    {LocaleStrings.proposal_disqualified_text}
                  </span>
                ) : response.markas == "resubmit" ? (
                  <span
                    className="badge badge-warning"
                    style={{ background: "#ffc107", color: "#000" }}
                  >
                    Re-Submission
                  </span>
                ) : (
                  <button
                    className="btn btn-custom-table-white"
                    onClick={this.makeShortList}
                  >
                    {this.state.loading
                      ? "Please wait"
                      : LocaleStrings.proposal_for_response_button_shortlist}
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div style={{ display: "flex" }}>
              <div className="action-button" style={{ marginLeft: 5 }}>
                <button
                  className="btn btn-custom-table-white"
                  onClick={this.viewResponse}
                >
                  {LocaleStrings.proposal_for_response_button_view}
                </button>
              </div>
              {confirmButton ? (
                <div className="action-button" style={{ marginLeft: 5 }}>
                  <button
                    className="btn btn-custom-table-white"
                    onClick={this.confirmProposal}
                  >
                    {this.state.welcomelogin
                      ? "Please Wait"
                      : LocaleStrings.proposal_for_response_button_welcome_email}
                  </button>
                </div>
              ) : (
                ""
              )}
              {sendwelcomeMail ? (
                <div className="action-button" style={{ marginLeft: 5 }}>
                  <button
                    className="btn btn-custom-table-white"
                    onClick={this.sendWelcomeMail}
                  >
                    {this.state.sendwelcomemail
                      ? "Please Wait"
                      : LocaleStrings.proposal_for_response_button_send_welcome_email}
                  </button>
                </div>
              ) : (
                ""
              )}

              <div className="action-button" style={{ marginLeft: 5 }}>
                {response.ticketurlsend == 0 ? (
                  <button
                    className="btn btn-custom-table-white"
                    onClick={this.sendTicket}
                  >
                    {LocaleStrings.proposal_for_response_button_send_ticket}
                  </button>
                ) : (
                  <button className="btn btn-custom-table-white">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <i
                        className="fa fa-check-circle steps-filled"
                        style={{ paddingTop: 0 }}
                        aria-hidden="true"
                      ></i>
                      <div>
                        {LocaleStrings.proposal_for_response_button_sent_ticket}
                      </div>
                    </div>
                  </button>
                )}
              </div>

              {/* {shortListedActionVisible ?
                <div className="action-button" style={{marginLeft: 5}}>
                    <button className="btn btn-custom-table-white" onClick={this.sendTicket}>{LocaleStrings.proposal_for_response_button_send_ticket}</button>
                </div>
                : ''
                } */}
            </div>
          )}
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    allSpeakers: state.allSpeakers,
    allExhibitors: state.allExhibitors,
    allSponsors: state.allSponsors,
    userCategoryList: state.userCategoryList,
    proposalAttendeeList: state.proposalAttendeeList,
  };
};

export default connect(mapStateToProps, {
  openChangeReviewer,
  makeShortlisted,
  showError,
  showSuccess,
  openProposalResponseModal,
  createSpeaker,
  addAppUser,
  sendWelcomeMail,
  validateEmailForAppUser,
  openProposalSendTicketModal,
  fetchAllSpeakers,
  openProposalConfirmModal,
})(ResponseItem);
